import React from "react";

import Icons from "components/layout/icons";
import Localize from "components/service/localize";


const AttendanceTimeRecordItem = React.memo(({
        check_in_at,
        check_out_at,
        created_at,
        moment
    }) => {
    const checkInValue = check_in_at || created_at;
    const checkInMoment = moment(checkInValue);
    const hasCheckOut = Boolean(check_out_at);
    const isToday = checkInMoment.isSame(moment(), "day");
    const status = hasCheckOut ? "complete" : isToday ? "in-progress" : "missed";

    return (
        <div className={ `attendance-time-record ${ status }` }>
            <span className="attendance-time-record-date">
                { checkInMoment.format("DD.MM.YYYY") }
            </span>
            <strong>{ checkInMoment.format("HH:mm") }</strong>
            <Icons.Arrow type="full" />
            <strong className="attendance-time-record-end">
                {hasCheckOut ?
                    moment(check_out_at).format("HH:mm") :
                    <Localize>
                        {isToday ?
                            "ATTENDANCE.TimeRecords_InProgress" :
                            "ATTENDANCE.TimeRecords_Missed"}
                    </Localize>}
            </strong>
        </div>
    );
});

export default AttendanceTimeRecordItem;
